import { render, staticRenderFns } from "./index.vue?vue&type=template&id=007ed227&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=007ed227&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=007ed227&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ed227",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007ed227')) {
      api.createRecord('007ed227', component.options)
    } else {
      api.reload('007ed227', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=007ed227&scoped=true", function () {
      api.rerender('007ed227', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/index.vue"
export default component.exports